module.exports = __webpack_public_path__ + "982e5d8f139873abcc1356382a56c00d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/canals.png
// module id = 435
// module chunks = 0